<template>
  <section :class="`ryoma-page-${$route.name}`"> 

    <Screen
      :type="'image'"
      :imageUrl="banner" />

    <TextComponent 
      :title="$i18n.t('components.text.title')"
      :intro="$i18n.t('components.text.intro')"
      :text="$i18n.t('components.text.text')"
      :align="'left'"/>

    <DataContainer />
    
  </section>
</template>

<script>
// @ is an alias to /src
import TextComponent from '@/components/TextComponent.vue'
import DataContainer from '@/components/widgets/data-grid/Container.vue'

import Screen from '@/components/Screen.vue'

import aboutPic from '@/assets/images/pic-about.jpg'

export default {
  name: 'about',
  components: {
    TextComponent,
    DataContainer,
    Screen
  },
  data() {
    return {
      banner: aboutPic
    }
  }
}
</script>
